<template>
	<BaseButton :no-style="true" :is-active="isActive" @click="handleClick">
		<div
			data-test="portfolio-return-jumbo-chip"
			:class="[
				{ active: isActive },
				'performance-return-jumbo-chip display-flex flex-direction-column display-inline-block py-50 px-100'
			]"
		>
			<p class="text-color-content-secondary" v-html="formattedChipValue"></p>
			<p class="display-flex align-items-center font-weight-bold dark text-align-right delta mt-0">
				<span
					v-if="props.showReturnIndicator"
					:class="['mr-25', props.returnData.indicatorClass]"
					data-test="return-indicator"
				></span>
				<span>{{ props.returnData.return }}</span>
			</p>
		</div>
	</BaseButton>
</template>

<script setup lang="ts">
import { PerformanceReturnJumboChip, PerformanceReturnJumboChipEnum } from 'types/performance-portfolio';
import { computed } from 'vue';

interface Props {
	returnData: PerformanceReturnJumboChip;
	selectedChip: PerformanceReturnJumboChipEnum;
	showReturnIndicator?: boolean;
}

interface Emits {
	(e: 'return-chip-selected', value: PerformanceReturnJumboChipEnum): void;
}

const props = withDefaults(defineProps<Props>(), {
	showReturnIndicator: true
});

const emits = defineEmits<Emits>();

const isActive = computed((): boolean => props.selectedChip === chipEnum.value);

const chipEnum = computed((): PerformanceReturnJumboChipEnum => props.returnData.enum);

const chipValue = computed((): string => {
	if (props.returnData.footnote) {
		return `${props.returnData.name} <sup>${props.returnData.footnote}</sup>`;
	}
	return props.returnData.name;
});

const formattedChipValue = computed((): string => chipValue.value.replaceAll(' ', '&nbsp;'));

function handleClick(): void {
	if (!isActive.value) {
		emits('return-chip-selected', chipEnum.value);
	}
}
</script>

<style lang="scss" scoped>
@use '../../../styles/constants/colors' as *;
@use '../../../styles/components/performance-portfolio' as *;

.performance-return-jumbo-chip {
	border: 1px solid gray(20);
	border-radius: 8px;

	&:hover,
	&.active {
		border: 1px solid token('content-primary');
	}

	&.active {
		background: token('bg-secondary');
	}
}
</style>
